import React from 'react'

import {BASE_NUM_IMAGES} from './GridGallery'
import {Container, StyledSkeletonLoader, Wrapper, WrapperItem} from './styles'

export const GridGalleryLoading = () => {
  return (
    <Container>
      <Wrapper
        className={`--${BASE_NUM_IMAGES}-images`}
        height={360}
        mainColumnWidth="50%"
      >
        {Array.from({length: BASE_NUM_IMAGES}, (_, index) => (
          <WrapperItem key={index}>
            <StyledSkeletonLoader height="100%" />
          </WrapperItem>
        ))}
      </Wrapper>
    </Container>
  )
}
